import React from 'react';
import Alert from '@material-ui/lab/Alert';

const AlertMessage = ({ severity, message }) => {
	return (
		<div>
			<Alert severity={severity}>{message}</Alert>
		</div>
	);
};

export default AlertMessage;
